import React, { FC, InputHTMLAttributes } from 'react';

import * as S from './styles';

export interface IInputTimeProps {
  minProps: InputHTMLAttributes<HTMLInputElement>;
  secProps: InputHTMLAttributes<HTMLInputElement>;
  label: string;
}

const InputTime: FC<IInputTimeProps> = ({ label, minProps, secProps }) => (
  <S.Container>
    <S.Label>{label}</S.Label>
    <S.InputsContainer>
      <S.StyledInput
        type="number"
        placeholder="min"
        {...minProps}
      />
      <S.StyledInput
        type="number"
        placeholder="sec"
        {...secProps}
      />
    </S.InputsContainer>
  </S.Container>
);

export default InputTime;
